export const FETCH_CLOSE_BILL_REPORT_HEADER_REQUEST = 'FETCH_CLOSE_BILL_REPORT_HEADER_REQUEST';
export const FETCH_CLOSE_BILL_REPORT_HEADER_SUCCESS = 'FETCH_CLOSE_BILL_REPORT_HEADER_SUCCESS';
export const FETCH_CLOSE_BILL_REPORT_HEADER_FAILURE = 'FETCH_CLOSE_BILL_REPORT_HEADER_FAILURE';